// SuccessCard.tsx
import React from 'react';
import {
  Box,
  Typography,
  Button,
  CardContent,
  CardActions,
  Avatar,
  CircularProgress,
} from '@mui/material';
import { ACTION_BLUE } from '../../theme/theme';

// Define the props interface
interface SuccessCardProps {
  imageUrl: string;
  title: string;
  subtitle: string;
  buttonText: string;
  buttonNavigateTo: () => void;
  name_fa: string;
  name_en: string;
  version: string;
}

const SuccessCard: React.FC<SuccessCardProps> = ({
  imageUrl,
  title,
  subtitle,
  buttonText,
  name_fa,
  name_en,
  version,
  buttonNavigateTo,
}) => {
  return (
    <Box
      sx={{
        width: '100%',
        borderRadius: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <CircularProgress size={40} sx={{ color: '#FF833D', padding: '2px' }} />
      <Typography
        sx={{
          textAlign: 'right',
          color: '#25282E',
          fontWeight: '900',
          fontFamily: 'IRANYekanXFaNum',
          fontSize: '20px',
        }}
      >
        {title}
      </Typography>

      {/* Subtitle Section */}
      <Typography
        variant="body1"
        sx={{
          textAlign: 'right',
          fontSize: '14px',
          fontFamily: 'IRANYekanXFaNum',
          fontWeight: '500',
          lineHeight: 1.5,
          color: '#666666',
          margin: 8,
        }}
      >
        {subtitle}
      </Typography>

      {/* App Info Section */}
      <Box
        sx={{
          width: '100%',
          height: '50%',
          padding: 0,
          m: 0,
          borderRadius: 1,
          border: '1px solid #E5E5E8',
          backgroundColor: '#FFFFFF',
        }}
      >
        <CardContent
          sx={{
            display: 'flex',
            alignItems: 'center', // محور عمودی وسط‌چین
            justifyContent: 'flex-end', // محور افقی سمت راست
            gap: 2, // فاصله بین Avatar و متن
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row', // افقی چینش شود
              alignItems: 'center', // محور عمودی وسط‌چین
              gap: 2, // فاصله بین Avatar و متن
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column', // متن‌ها به صورت عمودی چیده شوند
                alignItems: 'flex-end', // متن‌ها به سمت راست چسبیده شوند
              }}
            >
              <Typography
                sx={{
                  textAlign: 'right',
                  color: '#1B1E24',
                  fontFamily: 'IRANYekanXFaNum',
                  fontWeight: '700',
                }}
              >
                {name_en} | {name_fa}
              </Typography>
              <Typography
                variant="body2"
                sx={{
                  textAlign: 'right',
                  color: '#60646E',
                  fontFamily: 'IRANYekanXFaNum',
                  fontWeight: '500',
                }}
              >
                ورژن : {version}
              </Typography>
            </Box>
            <Avatar
              src={imageUrl}
              alt="App Icon"
              sx={{
                width: 64,
                height: 64,
                borderRadius: 2,
                background: 'linear-gradient(0deg, #D9D9DD 0%, #D9D9DD 100%)',
              }}
            />
          </Box>
        </CardContent>
      </Box>

      {/* Button Section */}
      <CardActions sx={{ width: '100%', justifyContent: 'center', mt: 2 }}>
        <Button
          variant="contained"
          onClick={buttonNavigateTo}
          sx={{
            backgroundColor: ACTION_BLUE,
            color: 'white',
            fontFamily: 'IRANYekanXFaNum',
            fontWeight: '700',
            padding: '12px 16px',
            borderRadius: 1,
            '&:hover': {
              backgroundColor: '#1565C0',
            },
          }}
        >
          {buttonText}
        </Button>
      </CardActions>
    </Box>
  );
};

export default SuccessCard;
